const demo_app = {
    notification: '提示：先注册一个账号，再测试登录体验。',
};
export default demo_app;
